import moment from 'moment';
import { format } from 'date-fns';
import { StripeElementCard } from '@vue-stripe/vue-stripe';
import discover from 'assets/cards/discover.png'
import amex from 'assets/cards/amex.png'
import mastercard from 'assets/cards/mastercard.png'
import visa from 'assets/cards/visa.png'
import unknown from 'assets/cards/unknown.png'

export default {
	isBlank(str) {
		return !str || /^\s*$/.test(str);
	},
	amountToString(amount, currency) {
		return Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: currency,
		}).format(amount / 100);
	},
	getTransactionFee(amount) {
		if (amount <= 0) {
			return 0;
		}
		const stripeFee = 0.029;
		const dominionFee = 0.02;
		var step1 = amount + 0.3;
		var step2 = 1 - (stripeFee + dominionFee);
		var step3 = step1 / step2 - amount;
		return parseFloat(step3.toFixed(2));
	},
	returnStripeBrandCard(sbrand){
		const brand = sbrand.toLowerCase()
		if (brand === 'discover'){
			return discover
		} else if (brand === 'amex'){
			return amex
		} else if (brand === 'mastercard'){
			return mastercard
		} else if (brand === 'visa'){
			return visa
		} else {
			return unknown
		}
	},
	isEmptyNotNull(value) {
		if (value == null) {
			return null;
		} else if (value == '' || value.length <= 0) {
			return false;
		}
		return true;
	},
	isValidEmail(email) {
		if (email == null) {
			return null;
		}
		var check = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return check.test(email);
	},
	secondsToDate(value){
		if (value == null) {
			return null;
		}
		return moment(new Date(value * 1000)).format("MMMM DD, yyyy")
	},
	formatDate(value, formatString, useMoment) {
		if (value == null) {
			return null;
		}
		var dateString = formatString;
		if (dateString == null) {
			dateString = 'MMMM DD, yyyy';
		}
		if (useMoment) {
			return moment(value).format(dateString);
		} else {
			return format(value, dateString);
		}
	},
};
